import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const getStatusClass = (status) => {
  const statusMap = {
    requested: "status-requested",
    current: "status-current",
    sent: "status-sent",
    approved: "status-approved",
    expired: "status-expired",
    unsent: "status-unsent",
    callback: "status-callback",
    completed: "status-completed",
    scheduled: "status-scheduled",
    confirmed: "status-confirmed",
  };
  return statusMap[status] || "status-current";
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const QUOTE_STATUSES = [
  { value: "requested", label: "Requested", color: "violet" },
  { value: "current", label: "Current", color: "blue" },
  { value: "sent", label: "Sent", color: "sky" },
  { value: "approved", label: "Approved", color: "emerald" },
  { value: "scheduled", label: "Scheduled", color: "slate" },
  { value: "confirmed", label: "Confirmed", color: "slate" },
  { value: "completed", label: "Completed", color: "emerald" },
  { value: "expired", label: "Expired", color: "amber" },
  { value: "unsent", label: "Unsent", color: "orange" },
  { value: "callback", label: "Callback", color: "rose" },
];

export const EMPLOYEE_TYPES = [
  { value: "lowrise_crew", label: "Lowrise Crew" },
  { value: "highrise_crew", label: "Highrise Crew" },
  { value: "quoter", label: "Quoter" },
  { value: "office", label: "Office" },
];

export const JOB_TYPES = [
  { value: "lowrise", label: "Lowrise (Ladder/Pole)" },
  { value: "bosuns_chair", label: "Bosun's Chair" },
  { value: "highrise", label: "Highrise" },
];

export const USER_ROLES = [
  { value: "office_manager", label: "Office Manager" },
  { value: "employee", label: "Employee" },
];
